<span [ngClass]="{'opacity-0': isLoading}"><ng-content></ng-content></span>
<div class="loader" *ngIf="isLoading">
  <div class="la-ball-pulse">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
